/* eslint-disable */
import React, { useState, useRef, useEffect } from 'react';
import NavFormIndustryDropdown from '../NavFormIndustryDropdown';

const MCDropdownFilter = ({ filterOptions, handleFilterSubmit, selectedFilters, setSelectedFilters }) => {
  const [filterDisplay, setFilterDisplay] = useState({
    partners: false,
    office: false,
    region: false,
    revenue_band: false,
    status: false,
    binder_type: false,
    mapping_status: false,
    entity_type: false
  })

  const mcFilterRef = useRef(null);

  // Close dropdowns if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        event.target.closest('.mc-filter-option, .mc-filter-popover, .naics-code-filter')
      ) {
        return; // click was on a header or inside an open dropdown
      }

      setFilterDisplay({
        partners: false,
        office: false,
        region: false,
        revenue_band: false,
        status: false,
        binder_type: false,
        mapping_status: false,
        entity_type: false
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const updateFilters = ({ target }) => {
    const { name, value, checked } = target;

    setSelectedFilters((prevState) => {
      let prevValues = [...(prevState[name] || [])];

      // If "All" or "Blank" is checked, clear all other options
      if (value === "All" || value === "Blank") {
        return {
          ...prevState,
          [name]: checked ? [value] : [],
        };
      }

      if (prevValues.includes("All") || prevValues.includes("Blank")) {
        prevValues = prevValues.filter((item) => item !== "All" && item !== "Blank");
      }

      // Toggle the selected filter values
      const updatedValues = checked ? [...prevValues, value] : prevValues.filter((item) => item !== value);

      return {
        ...prevState,
        [name]: updatedValues,
      };
    });
  };

  const handleFilterDisplay = (filter) => {
    setFilterDisplay(prevState => {
      let trueFalse = !prevState[filter];

      let newFilters = Object.keys(prevState).reduce((fil, key) => {
        fil[key] = key === filter ? trueFalse : false;
        return fil;
      }, {});

      return newFilters;
    })
  }

  const toOption = (item) => Array.isArray(item) ? { label: item[0], value: item[1] } : { label: item, value: item };

  const buildFilter = ({ list, selected, key, label, styleName }) => {
    if (!list) return null;

    const options = list.map(toOption);
    const selectedValues = Array.isArray(selected) ? selected : selected ? [selected] : [];

    // Show labels (e.g. "For Profit") in the summary, not raw values
    const displaySummary = selectedValues
      .map((v) => options.find((o) => o.value === v)?.label ?? v)
      .join(', ');

      return (
        <div className={styleName} id={key + '-filter'}>
          <div className='mc-filter-option text-left' onClick={() => handleFilterDisplay(key)}>
            <span style={{ marginRight: '2px' }}>{label}</span>
            <div className='fa fa-caret-down'></div>{' '}
            <span style={{ color: '#3f9a10' }}>{`(${displaySummary})`}</span>
          </div>
          {
            filterDisplay[key]
              ? (<div className='mc-filter-popover'>
                {options.map(({ label: optLabel, value }) => {
                  return (
                    <label key={value} className='option-dropdown-filter'>
                      <input
                        type="checkbox"
                        name={key}
                        value={value}
                        checked={selectedValues.includes(value)}
                        onChange={updateFilters}
                      />
                      {optLabel}
                    </label>
                  );
                })}
              </div>)
              : null
          }
        </div>
      )

  }

  return (
    <form id='dropdown-filter-id' ref={mcFilterRef} onSubmit={(e) => { handleFilterSubmit(e) }}>
      <div className='mc-dropdown-filters'>
        <div>
          <NavFormIndustryDropdown selectedCode={selectedFilters.naics_code} codeOptions={filterOptions.naics_code} setSelectedFilters={setSelectedFilters} page='manageClients' />
          {buildFilter({
            list: filterOptions.entity_type,
            selected: selectedFilters.entity_type,
            key: 'entity_type',
            label: 'Entity Type',
            styleName: 'entity_type-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.partners,
            selected: selectedFilters.partners,
            key: 'partners',
            label: 'Partner',
            styleName: 'partner-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.office,
            selected: selectedFilters.office,
            key: 'office',
            label: 'Office',
            styleName: 'office-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.region,
            selected: selectedFilters.region,
            key: 'region',
            label: 'Region',
            styleName: 'region-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.revenue_band,
            selected: selectedFilters.revenue_band,
            key: 'revenue_band',
            label: 'Revenue',
            styleName: 'revenue-band-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.status,
            selected: selectedFilters.status,
            key: 'status',
            label: 'Status',
            styleName: 'status-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.binder_type,
            selected: selectedFilters.binder_type,
            key: 'binder_type',
            label: 'Binder Type',
            styleName: 'binder_type-filter mc-filter-item-side-bar',
          })}
          {buildFilter({
            list: filterOptions.mapping_status,
            selected: selectedFilters.mapping_status,
            key: 'mapping_status',
            label: 'Mapping Status',
            styleName: 'mapping_status-filter mc-filter-item-side-bar',
          })}
        </div>
        <button className='filters-btn-manage-clients' type='submit'>Apply Filters</button>
      </div>
    </form>
  )
}

export default MCDropdownFilter;
